<template>
  <div id='alertPage'>
		    <div class='alertBox'>
		 
		          <div class='alertBoxtop' >
		              <div class='alertBoxName' >NUTRIPACKS 橘袋</div>
		              <div class='alertBoxTxt'>{{alertMsg}}</div>  
		          </div> 
		          <div class='alertBtn'>
		                <div @click='closealert'>确定</div>
		          </div>
		    </div>
		    <div class='alertCover' @click="closealert"></div>  
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    alertMsg: String,
  },
  data:function(){
    return{
      message:"",
      placeholderTxt:"请输入…",

    }
  },
 
 created:function(){
 
 },
  watch:{
    alertMsg:{
        handler(newValue, oldValue) {
　　　　　
　　　　},
    }
  },
  methods: {
   
	// 关闭提示
    closealert(){ 
			 
            // this.$emit('alertShowFN',false)     //传值给父组件  
			this.$parent.closeAlertShow()       //使用父组件的方法
	},
  }
}
</script>  

<style>
	#alertPage{
	  position: fixed;
	  width: 7.5rem;
	  height: 100vh;
	  top:0;
	  left: 0;
	  z-index: 300;
	  font-family:PingFangSC;
	  left:50%;
	  transform: translate(-50%,0); 
	}
	.alertCover{
	  width: 7.5rem;
	  height: 100vh;
	  background: rgba(0, 0, 0, 0.5);
	}
	
	.alertBox{
	  width: 5.5rem;
	  position: absolute;
	  left: 50%;
	  top:50%;
	  transform: translate(-50%, -50%);  
	  background-color: #fff;
	  border-radius: 0.2rem;
	}
	.alertBoxtop{
	  padding: 0 0.5rem 0.5rem;
	}
	.alertBoxName{
	  min-height: 1rem;
	  line-height: 1rem;
	  text-align: left;
	  font-size: 0.34rem;
	  color: #333333;
	  font-family:PingFangSC-Medium,PingFang SC;
	  font-weight:bold;
	  
	}
	.alertBoxTxtName{
	  color: rgba(0, 0, 0, 1);
	}
	.alertBoxTxt{
		text-align: left;
	  font-size: 0.28rem;
	  font-family:PingFangSC-Regular,PingFang SC;
	  font-weight:400;
	  line-height: 0.4rem;
	  color: #787878;
	}
	.alertBoxTxt span{
	  color:rgba(0, 0, 0, 0.6);
	}
	.alertBtn{
	  display: flex;
	  padding: 0.2rem 0;
	  border-top: 0.01rem solid #BBBBBB;
	}
	.alertBtn div{
	  width: 6rem;
	  text-align: center;
	  height:0.48rem;
	  font-size: 0.32rem;
	  letter-spacing: 0.1rem;
	  line-height: 0.48rem;
	  border-right: 1px solid #BBBBBB;
	  font-family:PingFangSC-Medium,PingFang SC;
	  font-weight:400;
	  color: #666666;
	}
	.alertBtn div:last-child{
	  border-right: none;
	}
</style>